import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './../AuthContext'; // Import useAuth hook
import {apiDoLogin, proxy} from './../process/api';


const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const { login, isLoggedIn, logout } = useAuth(); 
    const [isLoginError, setLoginError] = useState(false);
    const [loginErrorMessage, setLoginErrorMsg] = useState('');
   
     

    const checkPreLoginMsg = async () =>{

     

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/uploadstatus`, {}, "get");
        return reportAPIResponse;


    }

    const handleSubmit = async (event) => {
        event.preventDefault();
      
        var btnLogin =  document.getElementById('btnLogin');
        btnLogin.innerText ='Validating...';
        const apiEndpoint = '/api/auth/login'; 
        const body ={
            "username":username,
            "password":password
        }
        const apiResponse =  await apiDoLogin(apiEndpoint,body,'post');

            if(apiResponse.token){
                if(password == "123" || password == "1234"){
                   
                    localStorage.setItem("token", apiResponse.token);
                    navigate('/change-password-outer'); 
                    return;
                }

                localStorage.setItem("username", username);
                const isLoginSuccess =true;
                localStorage.setItem("token", apiResponse.token);

                login(apiResponse.token);

                var loginPreCheck = await checkPreLoginMsg();

                if(loginPreCheck.upload_status == "Y"){
                    alert(loginPreCheck.msg);
                    logout();
                }else{
                     navigate('/dashboard-loader'); 
                }
               
                btnLogin.innerText ='Login';
                
            }else{
                //alert("Error: "+apiResponse.details);
                setLoginErrorMsg('Unable to login. '+apiResponse.details);
                setLoginError(true);
                btnLogin.innerText ='Login';
              
            }
        
        

        
    };

    return (
        <div style={{background:"url(/../../images/bg.jpg) ", backgroundPosition:"center center", backgroundSize:"cover"}}>
        <div className="container" >
            <div className='custom-login-container'>
            <div className='row ' style={{flexDirection:"row-reverse", justifyContent:"center"}}>
      {/* <div className='col-md-7'>

            <img src="../../no-build/login-left.png?" alt="LEFT PROMO IMAGE" className='img-responsive' />
        </div> */ }

        <div className='col-md-5 col-xs-12 ' >

<div className='login-outer-wrapper'>
       
        <div className='login-wrapper' style={{}}>
        <img src="../../images/logo.png" alt='LOGO' className='brand-image' />
            <img src="/../../images/dart-logo.png" alt='DART' style={{maxWidth:"160px", margin:"0px auto 20px ", display:"block"}} />
       
         
            <form onSubmit={handleSubmit}>

{isLoginError && <div className='alert alert-danger'>{loginErrorMessage}</div> }
                <div className="mb-3">
                    <label htmlFor="username" className="form-label">Username</label>
                    <input
                        type="text"
                        className="form-control"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button type="submit" className="btn btn-primary btn-block btn-md" id='btnLogin'>Login</button>
            </form>
            </div>
            </div>

</div>
</div>  </div>
        </div></div>
    );
};

export default Login;

